import React from 'react'
import { Linking, View } from 'react-native'
import { connect } from 'react-redux'
import type { AppointmentType } from '@dialogue/timekeeper'
import type { NativeStackNavigationProp } from '@react-navigation/native-stack'

// Components
import AppointmentBooking from 'APP/Components/AppointmentBooking'

import Styles from './style'
import Analytics from 'APP/Services/Analytics'
import type { EventProperties } from 'APP/Services/Analytics'
import type { RootState } from 'APP/Store/CreateStore'

// TODO: {Typescript} consider sharing with SelfNavigationProps['microAppProps'] from 'APP/Lib/MicroAppNavHelper' —
// structurally similar but types post.props.microapp.searchterm and an index signature. Verify compatibility before consolidating.
interface MicroAppProps {
  displayMode?: string
  post?: {
    props?: {
      microapp: {
        appointment_type?: AppointmentType
      }
    }
  }
}

interface MicroAppScreenOwnProps {
  navigation?: NativeStackNavigationProp<ReactNavigation.RootParamList>
  route?: {
    params?: {
      title?: string
      microAppProps?: MicroAppProps
    }
  }
}

type MicroAppScreenProps = MicroAppScreenOwnProps & ReturnType<typeof mapStateToProps>

interface TrackPayload {
  name?: string
  props?: EventProperties
}

class MicroAppScreen extends React.Component<MicroAppScreenProps> {
  componentDidMount() {
    const { title } = this.props
    this.props.navigation?.setOptions({ title })
  }

  closeMicroApp = () => {
    this.props.navigation!.goBack()
  }

  track = (payload: TrackPayload) => {
    const { name, props } = payload
    if (name && props) {
      if (
        name === 'Health Resource Search Requested' ||
        name === 'Health Resource Result Clicked'
      ) {
        const analyticsEvent = name.replace(/ /g, '_').replace(/[A-Z]/g, (x) => x.toLowerCase())
        Analytics.trackEvent(analyticsEvent, props)
      }
    }
  }

  openUrl = (url: string) => {
    // @ts-expect-error: Linking.canOpenURL returns a Promise, so this check is always true (existing behaviour, kept as is)
    if (url && Linking.canOpenURL(url)) {
      Linking.openURL(url)
    }
  }

  call = (number: string) => {
    const telURL = `tel:${number && number.trim && number.trim()}`
    // @ts-expect-error: Linking.canOpenURL returns a Promise, so this check is always true (existing behaviour, kept as is)
    if (telURL && Linking.canOpenURL(telURL)) {
      Linking.openURL(telURL)
    }
  }

  getDisplayStyle = (displayMode?: string) => {
    switch (displayMode) {
      case 'fullscreen':
        return Styles.navContainerNavbarOverride
      case 'drawer':
        return Styles.navContainerDrawer
      default:
        return Styles.navContainer
    }
  }

  render() {
    const props = {
      close: this.closeMicroApp,
      trackEvent: this.track,
      openUrl: this.openUrl,
      callNumber: this.call,
      userLocation: this.props.userLocation,
      ...this.props.microAppProps,
    }

    const displayMode = this.props.microAppProps && this.props.microAppProps.displayMode

    return (
      <View style={this.getDisplayStyle(displayMode)}>
        <AppointmentBooking
          // @ts-expect-error: microapp.appointment_type can be missing; AppointmentBooking re-reads the scheduling props from `post` (useCompatibility)
          appointment_type={props?.post?.props?.microapp.appointment_type}
          {...props}
        />
      </View>
    )
  }
}

const mapStateToProps = (state: RootState, props: MicroAppScreenOwnProps) => {
  const userId = (state.patient && state.patient.profile && state.patient.profile.id) || null

  const userLocation =
    (state.patient && state.patient.profile && state.patient.profile.location) || null

  return {
    ...props.route?.params,
    userId,
    userLocation,
  }
}

export default connect(mapStateToProps)(MicroAppScreen)
